import { computed, signal } from '@/react/core/reactive.ts'

export const [showTrainingMode, setShowTrainingMode] = signal(false)

export const queryTrainingMode = computed(() => {
  return showTrainingMode()
})
